import { useTheme } from '@mui/material'
import { lighten } from '@mui/material/styles'

import { useCustomModal, useWhiteLabelOverrides } from 'src/hooks'
import { InfoLetterIcon } from 'src/assets/icons/v2/InfoLetterIcon'
import { FabSt } from '../page-fab/page-fab.styled'
import { AboutThisPageModal } from './about-this-page-modal'

interface IProps {
  color?: string
  hoverColor?: string
  locale: string
  whiteLabelId?: string | null
}

export const AboutThisPageBanner = ({ color, hoverColor, locale, whiteLabelId }: IProps) => {
  const { handleClose, handleOpen, open } = useCustomModal()
  const theme = useTheme()
  const { data: overrides } = useWhiteLabelOverrides(whiteLabelId, locale, open)

  const resolvedColor = color ?? theme.palette.primary.main
  const resolvedHoverColor = hoverColor ?? lighten(resolvedColor, 0.2)

  return (
    <>
      <FabSt
        id="about-this-page-banner"
        aria-label="about-this-page-button"
        size="large"
        onClick={handleOpen}
        sx={{
          backgroundColor: resolvedColor,
          '&:hover': {
            backgroundColor: resolvedHoverColor,
          },
        }}
      >
        <InfoLetterIcon size={38} />
      </FabSt>
      <AboutThisPageModal
        handleClose={handleClose}
        open={open}
        overrides={overrides || undefined}
      />
    </>
  )
}
